import { LOCAL_STORAGE_TO_PRESERVE } from '../entities/local-storage-ids.entity';

export function ClearLocalStorage(exceptions: string[] = LOCAL_STORAGE_TO_PRESERVE): void {
    for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i) ?? '';

        // Match to startsWith to allow for local storage keys like columns-{userID}
        const isWhitelisted = exceptions.some(exception => key.startsWith(exception));

        if (!isWhitelisted) {
            localStorage.removeItem(key);
        }
    }
}
